import React, { useRef, useState } from "react";
import { walletRepository } from "../../../../repositories/WalletRepository";
import Loader from "../../components/Loader";

interface UploadTransactionImageButtonProps {
    imageUrl?: string;
    onImageUploaded: (imageUrl: string) => void;
    onImageRemoved: () => void;
}

const UploadTransactionImageButton: React.FC<UploadTransactionImageButtonProps> = ({
    imageUrl,
    onImageUploaded,
    onImageRemoved,
}) => {
    const imageInputRef = useRef<HTMLInputElement>(null);
    const [isUploading, setIsUploading] = useState(false);

    const handleImagePick = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) {
            return;
        }

        try {
            setIsUploading(true);
            const uploadedImageUrl = await walletRepository.uploadImage(file);
            onImageUploaded(uploadedImageUrl);
        } catch (error) {
            console.error("Error uploading image", error);
        } finally {
            setIsUploading(false);
            event.target.value = "";
        }
    };

    return (
        <>
            {!imageUrl && (
                <div className="mt-2 flex flex-row justify-end gap-3">
                    <button
                        type="button"
                        className="text-brand-orange cursor-pointer h-6 w-6 flex items-center justify-center"
                        onClick={() => imageInputRef.current?.click()}
                        title="Upload image"
                        aria-label="Upload image"
                        disabled={isUploading}
                    >
                        {isUploading ? <Loader xsmall /> : <span className="material-icons">add_photo_alternate</span>}
                    </button>
                    <input
                        ref={imageInputRef}
                        type="file"
                        accept="image/*"
                        className="hidden"
                        onChange={handleImagePick}
                    />
                </div>
            )}
            {imageUrl && (
                <div className="mt-2 w-full max-w-xs aspect-video overflow-hidden rounded-xl border border-brand-bg-5 relative">
                    <img src={imageUrl} alt="" className="w-full h-full object-cover" />
                    <button
                        type="button"
                        className="absolute top-2 right-2 w-7 h-7 rounded-full bg-black/60 text-white flex items-center justify-center hover:bg-black/75"
                        onClick={onImageRemoved}
                        aria-label="Remove image"
                        title="Remove image"
                    >
                        <span className="material-icons text-base">close</span>
                    </button>
                </div>
            )}
        </>
    );
};

export default UploadTransactionImageButton;
